// Etichette italiane leggibili per i codici contatore (RICOH/Printanista).
// Allineato alla funzione backend meter_label() in printanista_match.py.
const METER_LABELS = {
  PageCountMono: "Totale pagine mono",
  PageCountColor: "Totale pagine colore",
  PageCountTotal: "Totale pagine",
  TotalImpressionsMono: "Totale impressioni mono",
  TotalImpressionsColor: "Totale impressioni colore",
  TotalImpressions: "Totale impressioni",
  TotalPagesFullColor: "Totale pagine full color",
  TotalPagesSingleColor: "Totale pagine single color",
  TotalPagesTwoColor: "Totale pagine bicolore",
  PageCountCopyMono: "Copie mono",
  PageCountCopyColor: "Copie colore",
  PageCountCopy: "Copie totali",
  CopyPagesFullColor: "Copie full color",
  CopyPagesSingleColor: "Copie single color",
  PageCountPrinterMono: "Stampe mono",
  PageCountPrinterColor: "Stampe colore",
  PageCountPrinter: "Stampe totali",
  PrinterPagesFullColor: "Stampe full color",
  PrinterPagesSingleColor: "Stampe single color",
  PrinterPagesTwoColor: "Stampe bicolore",
  DevelopmentMono: "Sviluppo mono",
  DevelopmentColor: "Sviluppo colore",
  DevelopmentTotal: "Sviluppo totale",
  SheetCountTotal: "Totale fogli",
  TabloidCountMono: "Tabloid mono",
  TabloidCountTotal: "Tabloid totale",
  TabloidSheetCountTotal: "Tabloid totale fogli",
};

const REPL = [
  ["Page Count", "Totale pagine"], ["Total Pages", "Totale pagine"],
  ["Total Impressions", "Totale impressioni"], ["Copy Pages", "Copie"],
  ["Printer Pages", "Stampe"], ["Sheet Count", "Totale fogli"],
  ["Development", "Sviluppo"], ["Mono", "mono"], ["Color", "colore"],
  ["Full", "full"], ["Single", "single"], ["Two", "bi"], ["Total", "totale"],
  ["Printer", "stampe"], ["Copy", "copie"], ["Count", ""], ["Page", "pagine"],
];

// Nome italiano leggibile per un codice contatore; se sconosciuto, prova una
// traduzione per token, altrimenti ritorna il codice originale.
export function meterLabelIt(code) {
  if (!code) return "";
  if (METER_LABELS[code]) return METER_LABELS[code];
  let s = String(code).replace(/(?<!^)(?=[A-Z])/g, " "); // split CamelCase
  for (const [a, b] of REPL) {
    const esc = a.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    s = s.replace(new RegExp("\\b" + esc + "\\b", "g"), b); // confini di parola: evita doppioni (es. "Totale")
  }
  return s.replace(/\s+/g, " ").trim() || String(code);
}
